// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  text-align: center;
}

.icon1 {
  font-size: 60px;
}

.icon2 {
  font-size: 30px;
}

.head {
  font-weight: bold;
  font-size: 16px;
}

.small {
  margin-top: 2%;
  font-size: 12px;
}

ion-card {
  --background: #f7f7f7;
  border: 1px solid #c4c4c4;
}

.trans1 {
  font-weight: bold;
  font-size: 12px;
  text-align: left;
}

.trans {
  font-weight: bold;
  font-size: 20px;
  position: relative;
  text-align: right;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.padding2 {
  margin-left: 5%;
  margin-right: 5%;
}

.col2 {
  margin-top: -5%;
}`, "",{"version":3,"sources":["webpack://./src/app/all-services/all-services.page.scss","webpack://./../../Open%20Source/loan-mobile-app/src/app/all-services/all-services.page.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;ACCJ;;ADEA;EACI,eAAA;ACCJ;;ADEA;EACI,eAAA;ACCJ;;ADEA;EACI,iBAAA;EACA,eAAA;ACCJ;;ADEA;EACI,cAAA;EACA,eAAA;ACCJ;;ADEA;EACI,qBAAA;EACA,yBAAA;ACCJ;;ADEA;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;ACCJ;;ADEA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;ACCJ;;ADEA;EACI,eAAA;EACA,gBAAA;ACCJ;;ADEA;EACI,eAAA;ACCJ","sourcesContent":["ion-toolbar {\n    text-align: center;\n}\n\n.icon1 {\n    font-size: 60px;\n}\n\n.icon2 {\n    font-size: 30px;\n}\n\n.head {\n    font-weight: bold;\n    font-size: 16px;\n}\n\n.small {\n    margin-top: 2%;\n    font-size: 12px;\n}\n\nion-card {\n    --background: #f7f7f7;\n    border: 1px solid #c4c4c4;\n}\n\n.trans1 {\n    font-weight: bold;\n    font-size: 12px;\n    text-align: left;\n}\n\n.trans {\n    font-weight: bold;\n    font-size: 20px;\n    position: relative;\n    text-align: right;\n    top: 35%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.padding2 {\n    margin-left: 5%;\n    margin-right: 5%;\n}\n\n.col2 {\n    margin-top: -5%;\n}","ion-toolbar {\n  text-align: center;\n}\n\n.icon1 {\n  font-size: 60px;\n}\n\n.icon2 {\n  font-size: 30px;\n}\n\n.head {\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.small {\n  margin-top: 2%;\n  font-size: 12px;\n}\n\nion-card {\n  --background: #f7f7f7;\n  border: 1px solid #c4c4c4;\n}\n\n.trans1 {\n  font-weight: bold;\n  font-size: 12px;\n  text-align: left;\n}\n\n.trans {\n  font-weight: bold;\n  font-size: 20px;\n  position: relative;\n  text-align: right;\n  top: 35%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.padding2 {\n  margin-left: 5%;\n  margin-right: 5%;\n}\n\n.col2 {\n  margin-top: -5%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
